import { createModulePage } from '../../components/generic/createModulePage';
import { initializeModule } from '../../utils/configInit';
import { supplierRatingConfig } from './supplierRatingConfig';
import { createSupplierRatingValidationSchema } from './supplierRatingValidation';

/**
 * Initialize the SupplierRating module using generic utilities
 */
const { config: initializedConfig } = initializeModule(
  supplierRatingConfig,
  createSupplierRatingValidationSchema
);

/**
 * Create the SupplierRatingPage using the generic module page factory
 */
const SupplierRatingPage = createModulePage(
  initializedConfig,
  {
    displayName: 'SupplierRatingPage',
    description: 'Supplier Rating Management System - Supplier performance evaluation and scoring'
  }
);

export default SupplierRatingPage;
